module.exports = __webpack_public_path__ + "img/sales_widget.f9c50ec9.svg";